import react from 'react';
import classes from './Banner.module.css';


const Banner=()=>{
    return <section className={classes.main}> 
            
 <p  className={classes.Abtp}>&emsp;&emsp;Professional EMS service provider INFISEA is headquartered in India and was founded with the goal of offering a one-stop shop for all worldwide electronic manufacturing services with a focus on quality. To meet the needs of innovators in the electronics sector, services such R&D, product design and development, PCB manufacturing, component sourcing, PCB assembly, casing, packaging, OEM branding, and so forth are provided. All of our services are readily available to clients, and we provide real-time progress tracking to guarantee prompt delivery of high-quality work. Our success has been fueled by the organizational excellence-driven action, which has allowed us to achieve extraordinary results via the efforts of a dedicated, honest, and transparent staff that takes pride in delivering the best service with a high rate of customer satisfaction. </p>
              
            </section>
};


export default Banner;